import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-add-attribute-consequence',
  templateUrl: './add-attribute-consequence.component.html',
  styleUrls: ['./add-attribute-consequence.component.scss'],
})
export class AddAttributeConsequenceComponent implements OnInit {
  @Input() addAttribute: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();
  dateOptions: any;
  periods: any;

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  ngOnInit(): void {
    this.periods = [
      { value: 'YEAR', text: 'YEARS' },
      { value: 'MONTH', text: 'MONTHS' },
      { value: 'WEEK', text: 'WEEKS' },
      { value: 'DAY', text: 'DAYS' },
      { value: 'QUARTER', text: 'QUARTERS' },
    ];

    this.dateOptions = [
      { value: 'txnDate', text: 'Transaction Date' },
      { value: 'activityDate', text: 'Activity Date' },
    ];
  }

  initConsequenceObject(): void {
    console.log(this.addAttribute);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$AddAttribute',
    };
    if (this.addAttribute) {
      this.addAttribute.push(tmpObj);
    } else {
      this.addAttribute = [];
      this.addAttribute.push(tmpObj);
    }
    console.log(this.addAttribute);
  }

  updateConsequences() {
    this.debouncer.next(this.addAttribute);
  }

  removeConsequence(consequence) {
    this.addAttribute.splice(this.addAttribute.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
